import api from '@/utils/http'

/**
 功能：保存角色
 time: 2025-38-02 16:38:38
 **/
export function saveUser(data) {
    return api.post('/partner/partner/setUser', data)
}

/**
 功能：
 time: 2026/1/7 15:47
 **/
export function getUserInfo() {
    return api.get('/partner/partner/getInfo')
}

/**
 功能：
 time: 2026/1/7 16:08
 **/
export function savePass(data) {
    return api.post('/partner/partner/setPass', data)
}
